import { apiClientWH } from '@shared/services/ApiClient';

export interface PaymentMethod {
  id: number;
  method: string;
}

// La API devuelve directamente un array de PaymentMethod, no un objeto con data
export type PaymentMethodsResponse = PaymentMethod[];

export class PaymentMethodsApiAdapter {
  constructor() {
    // No necesitamos crear un cliente HTTP separado, usamos apiClientWH directamente
  }

  async getPaymentMethods(): Promise<PaymentMethodsResponse> {
    try {
      const response = await apiClientWH.get('/payment-methods');

      return response.data;
    } catch (error: any) {
      console.log('🔍 PaymentMethodsApiAdapter - Error:', error);
      throw error;
    }
  }
}
